import { render } from "./SetupAutoInvestment.vue?vue&type=template&id=56a42d34&scoped=true"
import script from "./SetupAutoInvestment.vue?vue&type=script&lang=js"
export * from "./SetupAutoInvestment.vue?vue&type=script&lang=js"

import "./SetupAutoInvestment.vue?vue&type=style&index=0&id=56a42d34&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a42d34"]])

export default __exports__